<template>
  <div class="wrapper">
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="运费金额">
        <el-input v-model="formData.deliveryFeeDeserved" :disabled="true">
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="托运人已预付">
        <el-input v-model="formData.allotTaxAmount" :disabled="true">
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="已预付金额">
        <el-input v-model="formData.payAmount" :disabled="true">
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="已预付油点">
        <el-input v-model="formData.payOil" :disabled="true">
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="预付运费" prop="amount">
        <!-- :disabled="!verificateCodeShow" -->
        <el-input
          v-model="formData.amount"
          type="number"
          min="0"
          :disabled="amountDisabled"
          @change="getAmount"
        >
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>
      <!-- 请选择手机号 -->
      <el-collapse v-model="activeNames" style="margin-bottom:20px">
        <el-collapse-item title="请选择手机号" name="1">
          <el-radio-group
            v-for="(phone1, index) in phoneArray"
            :key="index"
            v-model="queryObj.phone"
            :disabled="amountDisabled"
          >
            <el-radio :label="phone1" style="margin-right:10px">{{
              phone1
            }}</el-radio>
          </el-radio-group>
        </el-collapse-item>
      </el-collapse>
      <el-row :gutter="10">
        <el-col :span="20">
          <el-form-item label="获取验证码" prop="smsCode">
            <el-input
              v-model="formData.smsCode"
              placeholder="请输入验证码"
              :disabled="step1Flag"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <verificationCode
            ref="ishowRef"
            :api-fun="sendVerificationCode"
            :query-obj="queryObj"
            :disabled="step1Flag"
            @getSms="getSms"
          />
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" :disabled="step2Flag" @click="submit"
          >确认打款</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  prepayToDriver,
  getConfigPhone,
  sendVerificationCode
} from "@/api/transport";
import { sendCentralCode } from "@/api/InternetBanking";
import verificationCode from "@/components/verificationCode";
export default {
  components: {
    verificationCode
  },
  data() {
    return {
      amountDisabled: false,
      step1Flag: true,
      step2Flag: true,
      sendVerificationCode,
      dialogVisible: false,
      loading: false,
      tableData: [],
      sendCentralCode,
      formData: {
        amount: "",
        smsCode: ""
      },
      emptyForm: {},
      activeNames: ["1"],
      phoneArray: [],
      radio: "",
      backData: {
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      configPhone: "",
      queryObj: {
        phone: "",
        source: "platform",
        amount: "",
        code: "",
        pageForm: "prepay"
      },
      rules: {
        totalAmount: [
          { required: true, message: "请输入待打款金额", trigger: "blur" }
        ],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        amount: [{ required: true, message: "请输入预付运费", trigger: "blur" }]
      },
      count: 0
    };
  },
  computed: {
    verificateCodeShow() {
      return this.$store.getters.verificateCodeShow;
    }
  },
  watch: {
    "formData.amount"(val) {
      // console.log(val)
      if (this.queryObj.phone == "") {
        this.step1Flag = true;
      } else {
        if (val !== "") {
          this.step1Flag = false;
        } else {
          this.step1Flag = true;
          this.step2Flag = true;
        }
      }
      if (val !== "") {
        if (this.formData.smsCode !== "") {
          this.step2Flag = false;
        }
      }
    },
    "queryObj.phone"(val) {
      if (this.formData.amount !== "") {
        if (val !== "") {
          this.step1Flag = false;
        } else {
          this.step1Flag = true;
        }
      }
    },
    "formData.smsCode"(val) {
      // if(val!==''){
      //   this.step2Flag=false;
      // }else{
      //     this.step2Flag=true
      // }
    }
  },
  async created() {
    this.emptyForm = JSON.parse(JSON.stringify(this.formData));
    const partyType = this.$store.getters.party.partyType;
    //  获取配置的手机号 -
    let party = this.$store.getters.party;
    this.configPhone = party.phone;
    await getConfigPhone().then(res => {
      if (res.data && res.data.length > 0) {
        this.phoneArray = res.data || [];
      }
      if (this.phoneArray.includes(this.configPhone)) {
        this.queryObj.phone = this.configPhone;
      } else {
        this.queryObj.phone = "";
      }
    });

    let isShipment = partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    if (isShipment) {
      this.queryObj.source = "shipment";
    }
  },
  methods: {
    // 验证码逻辑，打开页面清空所有，填写金额和选择手机号并发送验证码成功后金额和手机号不可改，发送验证码成功后打款按钮可点击并一直可点击，验证码倒计时结束后可重新获取验证码
    getSms(data, arg) {
      // this.form.orderNo = data.orderNo
      // this.form.outTradeNo = data.outTradeNo
      // alert(22)
      this.amountDisabled = true;
      this.step2Flag = false;
    },
    show(row) {
      //查询到数据之前先展示空表单
      this.amountDisabled = false;
      this.step2Flag = true;
      this.queryObj.phone = "";
      this.formData = JSON.parse(JSON.stringify(this.emptyForm));
      this.$refs.formData.clearValidate();
      let {
        deliveryFeeDeserved,
        payAmount,
        allotTaxAmount,
        code,
        payOil
      } = row;
      this.queryObj.code = code;
      this.formData = {
        deliveryFeeDeserved,
        payAmount,
        allotTaxAmount,
        code,
        payOil,
        ...this.formData
      };
      // 验证码清空
      this.$refs.ishowRef.show = true;
    },
    getAmount() {
      this.formData.amount = this.formData.amount.replace(
        /([0-9]+\.[0-9]{2})[0-9]*/,
        "$1"
      );
      this.queryObj.amount = this.formData.amount;
    },
    // 提交
    submit() {
      this.queryObj.amount = this.formData.amount;
      this.formData.phone = this.queryObj.phone;
      this.$refs.formData.validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let response = await prepayToDriver(this.formData);
          rLoading.close();
          this.$message.success(response.msg);
          this.$emit("payOnlineclose");
          this.count = 0;
          this.dialogVisible = false;
          this.$refs.formData.resetFields();
        }
      });
    },
    // 关闭
    close() {
      this.$refs.formData.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
